import {
  getSections,
  addSection,
  addLesson,
  updateLesson,
  deleteLesson,
  reorderLessons,
} from '@/services/SuperAdminService/SuperAdminCourseManagementService';
import { getStandaloneLessons } from '@/services/SuperAdminLessonService';
import type { CourseSectionsService, LibraryLesson, ContentType, LessonType } from '../types';

/** List Content Management library (standalone) lessons for the "Add from Library" picker. */
const getLibraryLessons: NonNullable<CourseSectionsService['getLibraryLessons']> = async () => {
  const res = await getStandaloneLessons();
  if (!res.success || !res.data) {
    return { success: false, error: res.error || { message: 'Failed to load library lessons' } };
  }
  const data: LibraryLesson[] = res.data.map((l) => ({
    id: l.id,
    title: l.title,
    lessonType: l.lessonType as LessonType,
    contentType: (l.contentType as ContentType) ?? null,
    lessonContentDocument: l.lessonContentDocument ?? null,
    lessonContentScorm: l.lessonContentScorm ?? null,
    lessonContentMp4: l.lessonContentMp4 ?? null,
    lessonContentUrl: l.lessonContentUrl ?? null,
    lessonDuration: l.lessonDuration ?? null,
    description: l.description ?? null,
    ilts: l.iltsInfo
      ? {
          mode: l.iltsInfo.mode,
          meetUrl: l.iltsInfo.meetUrl ?? null,
          venue: l.iltsInfo.venue ?? null,
          startDate: l.iltsInfo.startDate ?? null,
          startTime: l.iltsInfo.startTime ?? null,
          endDate: l.iltsInfo.endDate ?? null,
          endTime: l.iltsInfo.endTime ?? null,
        }
      : null,
  }));
  return { success: true, data };
};

export const superAdminCourseSectionsService: CourseSectionsService = {
  getSections,
  addSection,
  addLesson,
  updateLesson,
  deleteLesson,
  reorderLessons,
  getLibraryLessons,
};
